export function removeElement(el) {
  el.parentNode.removeChild(el)
}

export function debounce(func, wait, immediate) {
  let timeout

  return function () {
    const context = this
    const args = arguments

    if (immediate && !timeout) func.apply(context, args)

    clearTimeout(timeout)

    timeout = setTimeout(function () {
      timeout = null
      if (!immediate) func.apply(context, args)
    }, wait)
  }
}

export function formdataToObject(formData) {
  const object = {}

  formData.forEach((value, key) => {
    // NOTE Reflect.has in favor of: object.hasOwnProperty(key)
    if (!Reflect.has(object, key)) {
      object[key] = value
      return
    }
    if (!Array.isArray(object[key])) {
      object[key] = [object[key]]
    }
    object[key].push(value)
  })

  return object
}
